import { useState } from 'react'

import { sortBy } from 'lodash'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import Constant from 'modules/core/store/models/Constant'

import { companyMainLocation } from 'modules/locations/store/collections/locations'

export const useDomainsList = () => {
  const [loading, setLoading] = useState(true)
  const [domains, setDomains] = useState<string[]>([])

  useAsyncData(async () => {
    const countryDomainOptions = new Constant({
      id: 'country_domain_options',
    })

    await countryDomainOptions.fetch()

    const country = companyMainLocation().attributes.country
    const sortedList = sortBy(countryDomainOptions.toJS().value, (item) => {
      return item.includes(country) ? 0 : 1
    })

    setDomains(sortedList)
    setLoading(false)
  }, [])

  return {
    domains,
    loading,
  }
}
